module.exports = __webpack_public_path__ + "static/media/30.a39b06c1.png";